/* Cart drawer add-on offers (Hagan 2026-10-20): up to 3 one-tap offers in the
   free-shipping box, rotating gently. Candidates come from
   snippets/gp-cart-nudge.liquid (JSON in [data-gp-nudge-data]):
     twin  another of the cart item's family ("Make it two!")
     goes  the cart item's "Goes great with" list
     fill  Best Sellers (age-graded)
   Offers are singles or pairs. Under the free-shipping threshold, offers that
   unlock it come first (fewest items, most relevant, least overspend), then
   the ones that get closest. Over it: "Goes great with your order".
   One tap adds every item through the cart API and fires the theme's own
   shapes:cart:afteradditem, so the drawer redraws exactly like Add to Cart.
   The drawer re-renders this box on every cart change; an observer rebuilds. */
(function () {
  var MAX_OFFERS = 3;
  var ROTATE_MS = 3200;
  var MAX_OVERSPEND = 2500; // cents: an unlocking offer may overshoot by max(gap, $25)
  var DOUBLES = ['cube-6pack', 'cube-4pack', 'fillers']; // "two of these" makes sense
  var COLLECT = ['cube-6pack', 'cube-4pack']; // collected: crews + "4-Packs" titles
  var PAIR_TWINS = ['cube-6pack', 'cube-4pack', 'book', 'character']; // two of the family pair up
  var JARS = ['water-toy', 'gift-set'];      // containers: one per offer
  var CREW_MAX = 4;                          // "Collect the crew!" offers up to 4 more
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    var f = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var a = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, a);
  }
  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  }

  // a variant named like something in the cart wins (Gumdrop jar -> Gumdrop
  // Mega Fillers); otherwise the first in-stock one
  function pickVariant(u, cartTitles) {
    for (var i = 0; i < u.variants.length; i++) {
      var t = u.variants[i].t;
      if (t !== 'Default Title' && cartTitles.indexOf(t) !== -1) return u.variants[i];
    }
    return u.variants[0];
  }

  function buildOffers(data) {
    var gap = data.gap;
    var under = gap > 0;
    var weight = under ? { twin: 3, goes: 2, fill: 1 } : { goes: 3, twin: 2, fill: 1 };
    var cartTitles = data.cart.map(function (c) { return c.vt; });
    // Best Sellers only stand in when nothing in the cart has matches - two
    // good offers beat a third random one
    var hasRelevant = data.units.some(function (u) { return u.kind !== 'fill'; });
    var units = data.units
      .filter(function (u) { return u.variants && u.variants.length; })
      .filter(function (u) { return !hasRelevant || u.kind !== 'fill'; })
      .map(function (u) {
        var v = pickVariant(u, cartTitles);
        // same brand as a cart item of the same kind (Sesame with Sesame)
        var same = data.cart.some(function (c) { return c.cat === u.cat && c.brand === u.brand; });
        return { u: u, v: v, w: weight[u.kind] || 1, price: v.p, same: same };
      });

    var offers = units.map(function (a) { return { items: [a], qty: [1], total: a.price, rel: a.w, min: a.w }; });
    if (under) {
      for (var i = 0; i < units.length; i++) {
        var a = units[i];
        if (a.u.kind === 'fill') continue;
        for (var j = i + 1; j < units.length; j++) {
          var b = units[j];
          if (b.u.kind === 'fill') continue;
          // one "make it two" per offer - except collectibles: two 4-packs
          // or two 6-packs is how people buy them
          // two of the family only for things people collect, same brand as the cart
          if (a.u.kind === 'twin' && b.u.kind === 'twin'
            && !(PAIR_TWINS.indexOf(a.u.cat) !== -1 && a.u.cat === b.u.cat && a.same && b.same)) continue;
          // never two jars in one offer
          if (JARS.indexOf(a.u.cat) !== -1 && JARS.indexOf(b.u.cat) !== -1) continue;
          offers.push({ items: [a, b], qty: [1, 1], total: a.price + b.price, rel: a.w + b.w, min: Math.min(a.w, b.w) });
        }
        if (DOUBLES.indexOf(a.u.cat) !== -1 && a.u.kind !== 'twin' && a.price < gap) {
          offers.push({ items: [a], qty: [2], total: a.price * 2, rel: a.w * 2 - 0.5, min: a.w });
        }
      }
    }

    if (under) {
      COLLECT.forEach(function (cat) {
        var crew = units.filter(function (u) { return u.u.kind === 'twin' && u.u.cat === cat && u.same; });
        var sum = 0;
        for (var c = 0; c < crew.length && c < CREW_MAX; c++) {
          sum += crew[c].price;
          if (c >= 2 && sum >= gap) {
            var its = crew.slice(0, c + 1);
            offers.push({ items: its, qty: its.map(function () { return 1; }), total: sum,
              rel: its.length * 3, min: 3, crew: true });
            break;
          }
        }
      });
    }

    var ranked;
    if (under) {
      var cross = offers.filter(function (o) {
        return o.total >= gap && o.total - gap <= Math.max(gap, MAX_OVERSPEND);
      }).sort(function (x, y) {
        // an offer is only as relevant as its least relevant item, so a pair
        // of matching items beats a lone Best Seller that happens to unlock
        return (y.min - x.min) || (x.items.length + x.qty[0] - y.items.length - y.qty[0])
          || (y.rel - x.rel) || (x.total - y.total);
      });
      var near = offers.filter(function (o) { return o.total < gap && !o.crew; })
        .sort(function (x, y) { return (y.min - x.min) || (y.total - x.total); });
      ranked = cross.concat(near);
    } else {
      ranked = offers.filter(function (o) { return o.items.length === 1; })
        .sort(function (x, y) { return y.rel - x.rel; });
    }

    // variety: no product appears in two offers
    var picked = [], used = {};
    for (var k = 0; k < ranked.length && picked.length < MAX_OFFERS; k++) {
      var o = ranked[k];
      var clash = o.items.some(function (it) { return used[it.u.pid]; });
      if (clash) continue;
      o.items.forEach(function (it) { used[it.u.pid] = true; });
      picked.push(o);
    }
    return picked;
  }

  function offerHTML(o, data, idx) {
    var s = data.strings, gap = data.gap;
    var names = o.items.map(function (it) {
      return it.u.title + (it.u.multi && it.v.t !== 'Default Title' ? ', ' + it.v.t : '');
    });
    // a line name the cart already shows drops off ("Light-Up Library™ – ")
    names = names.map(function (n) {
      var cut = n.indexOf(' \u2013 ');
      if (cut === -1) return n;
      var pre = n.slice(0, cut + 3);
      var shared = data.cart.some(function (c) { return (c.title || '').indexOf(pre) === 0; });
      return shared ? n.slice(cut + 3) : n;
    });
    var title = o.qty[0] === 2 ? '2 \u00d7 ' + names[0] : names.join(' + ');
    // collectibles of one kind read as a set: "Sammy, Blair + Alex 4-Packs"
    var cat0 = o.items[0].u.cat;
    if (o.items.length > 1 && COLLECT.indexOf(cat0) !== -1
      && o.items.every(function (it) { return it.u.cat === cat0; })) {
      var short = o.items.map(function (it) {
        return it.u.title.split(' Light-Up')[0].replace(/[\u00ae\u2122]/g, '').trim();
      });
      title = short.slice(0, -1).join(', ') + ' + ' + short[short.length - 1] + ' '
        + (cat0 === 'cube-4pack' ? '4-Packs' : '6-Packs');
    }
    var note = gap <= 0 ? s.goes_with
      : o.total >= gap ? s.unlocks
      : s.to_go.replace(/\{\{\s*amount\s*\}\}/, money(gap - o.total));
    var twin = o.items.some(function (it) { return it.u.kind === 'twin'; });
    var eyebrow = gap <= 0 ? '' : o.crew ? s.crew : twin ? s.make_two : '';
    var payload = o.items.map(function (it, i) { return { id: it.v.id, quantity: o.qty[i] }; });
    var label = o.items.length > 2 ? s.add_all : o.qty[0] > 1 ? s.add_two : o.items.length > 1 ? s.add_both : s.add;
    var imgs = o.items.concat(o.qty[0] === 2 ? [o.items[0]] : []).slice(0, 3).map(function (it) {
      var src = it.v.img || it.u.img;
      return src ? '<img src="' + esc(src) + '" alt="" loading="lazy" class="gp-nudge__img">' : '';
    }).join('');
    return '<div class="gp-nudge gp-offers__slide" role="group" aria-roledescription="slide" aria-label="' + (idx + 1) + ' / ' + '%N%' + '">'
      + '<a href="' + esc(o.items[0].u.url) + '" class="gp-nudge__media' + (o.items.length > 1 || o.qty[0] > 1 ? ' gp-nudge__media--pair' : '') + '" tabindex="-1" aria-hidden="true">' + imgs + '</a>'
      + '<div class="gp-nudge__body">'
      + (eyebrow ? '<span class="gp-nudge__eyebrow">' + esc(eyebrow) + '</span>' : '')
      + '<a href="' + esc(o.items[0].u.url) + '" class="gp-nudge__title">' + esc(title) + '</a>'
      + '<span class="gp-nudge__foot">'
      + '<span class="gp-nudge__meta">' + esc(money(o.total)) + ' · ' + esc(note) + '</span>'
      + '<button type="button" class="btn push-btn--no-shadow gp-nudge__btn" data-gp-add=\'' + esc(JSON.stringify(payload)) + '\'>' + esc(label) + '</button>'
      + '</span>'
      + '</div>'
      + '</div>';
  }

  function sectionIds() {
    if (typeof window.getCartSectionRequestIds === 'function') return window.getCartSectionRequestIds();
    var ids = (window.theme && window.theme.cartSectionIds) || {};
    return Object.keys(ids).map(function (k) { return ids[k]; });
  }

  function addItems(btn) {
    var items = JSON.parse(btn.getAttribute('data-gp-add'));
    var fd = new FormData();
    items.forEach(function (it, i) {
      fd.append('items[' + i + '][id]', it.id);
      fd.append('items[' + i + '][quantity]', it.quantity);
    });
    fd.append('sections', sectionIds().join(','));
    fd.append('sections_url', window.location.pathname);
    btn.disabled = true;
    btn.classList.add('is-loading');
    fetch(window.theme.routes.cart_add_url, {
      method: 'POST', body: fd,
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data && data.status) throw new Error(data.description || data.message || 'add failed');
      document.body.dispatchEvent(new CustomEvent('shapes:cart:afteradditem', {
        bubbles: true, detail: { response: data, sourceId: 'gp-cart-nudge' }
      }));
    }).catch(function () {
      btn.disabled = false;
      btn.classList.remove('is-loading');
    });
  }

  function render(root) {
    var script = root.querySelector('[data-gp-nudge-data]');
    if (!script) return;
    var raw = script.textContent;
    if (root.__gpRaw === raw && root.querySelector('.gp-offers')) return;
    root.__gpRaw = raw;
    var data;
    try { data = JSON.parse(raw); } catch (e) { return; }
    var offers = buildOffers(data);
    var old = root.querySelector('.gp-offers');
    if (old) old.remove();
    if (root.__gpTimer) { clearInterval(root.__gpTimer); root.__gpTimer = null; }
    if (!offers.length) return;
    var html = offers.map(function (o, i) { return offerHTML(o, data, i); }).join('').replace(/%N%/g, offers.length);
    var wrap = document.createElement('div');
    wrap.className = 'gp-offers';
    wrap.innerHTML = '<div class="gp-offers__track">' + html + '</div>'
      + (offers.length > 1 ? '<div class="gp-offers__dots" aria-hidden="true">'
        + offers.map(function (_, i) { return '<span class="gp-offers__dot' + (i ? '' : ' is-active') + '"></span>'; }).join('')
        + '</div>' : '');
    root.appendChild(wrap);

    var track = wrap.querySelector('.gp-offers__track');
    var dots = wrap.querySelectorAll('.gp-offers__dot');
    var at = 0;
    function show(i) {
      at = (i + offers.length) % offers.length;
      track.scrollTo({ left: at * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
    }
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }, { passive: true });
    // rotate gently; any touch, hover or focus stops it for good (not invasive)
    // once a shopper has touched the offers, they stay still for the visit
    function stop() {
      window.__gpNudgeTouched = true;
      if (root.__gpTimer) { clearInterval(root.__gpTimer); root.__gpTimer = null; }
    }
    ['pointerdown', 'touchstart', 'mouseenter', 'focusin', 'wheel'].forEach(function (ev) {
      wrap.addEventListener(ev, stop, { passive: true });
    });
    if (offers.length > 1 && !reduced && !window.__gpNudgeTouched) {
      root.__gpTimer = setInterval(function () {
        if (!wrap.isConnected) return stop();
        if (wrap.offsetParent === null || document.hidden) return; // drawer closed: hold
        show(at + 1);
      }, ROTATE_MS);
    }
  }

  window.gpCartNudgeOffers = buildOffers; // for QA scripts

  // capture phase: the cart drawer stops clicks from bubbling out of it
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-gp-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    addItems(btn);
  }, true);

  function scan() {
    document.querySelectorAll('[data-gp-nudge-root]').forEach(render);
  }
  var pending = null;
  new MutationObserver(function () {
    if (pending) return;
    pending = requestAnimationFrame(function () { pending = null; scan(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();

/* Gift message (2026-10-20, snippets/gp-gift-note + gp-gift-line + the
   drawer footer link in cart-footer): the order note, saved as people type -
   600ms after the last keystroke and again on blur. No readonly lock while
   saving (the stock CartNote one dropped keystrokes on phones). Check Out
   submits the note with the cart form anyway (form="cart"), so a message
   typed right before tapping it is never lost.
   Openers ([data-gp-gift-open]): the footer link above Check Out and the
   product-page line. They open the row, scroll it into view and focus the box
   inside the tap (so iOS raises the keyboard). The product-page line opens
   the cart drawer first; with an empty cart it shows its hint instead and
   leaves an intent, so the row opens by itself once something is added.
   Labels ([data-gp-gift-link]) read "added · Edit" while the cart has items
   and a note. Example messages rotate in the empty box (not with reduced
   motion). */
(function () {
  var timers = new WeakMap();
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var INTENT = 'gpGiftIntent';
  var hasNote = null; // unknown until the drawer box exists or a save happens

  function cartCount() {
    try {
      var st = window.Alpine && Alpine.store && Alpine.store('cart_count');
      if (st && typeof st.count === 'number') return st.count;
    } catch (err) { /* Alpine not booted yet */ }
    return (window.theme && window.theme.cartItemCount) || 0;
  }

  function count(el) {
    var out = el.parentNode.querySelector('[data-gp-gift-count]');
    if (!out) return;
    var left = (parseInt(out.getAttribute('data-limit'), 10) || 250) - el.value.length;
    out.textContent = left <= 40 ? left + ' characters left' : '';
  }

  // "Add a free gift message…" <-> "Gift message added · Edit"
  function syncLinks() {
    if (hasNote === null) return; // keep what the server rendered
    var added = hasNote && cartCount() > 0;
    document.querySelectorAll('[data-gp-gift-link]').forEach(function (b) {
      if (b.hasAttribute('data-gp-hinted')) return; // showing the empty-cart hint
      var label = b.querySelector('[data-gp-gift-label]');
      var text = b.getAttribute(added ? 'data-text-added' : 'data-text-empty');
      if (label && text && label.textContent !== text) label.textContent = text;
    });
  }

  function save(el) {
    clearTimeout(timers.get(el));
    var v = el.value;
    hasNote = v.trim() !== '';
    syncLinks();
    if (v === el.getAttribute('data-saved')) return;
    el.setAttribute('data-saved', v);
    fetch(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: v })
    }).catch(function () {
      el.setAttribute('data-saved', ''); // retry on the next change
    });
  }

  function drawerBox() {
    return document.querySelector('#cartDrawer [data-gp-gift-note]');
  }

  function openRow(box, focus) {
    var details = box.closest('details');
    if (details && !details.open) details.open = true;
    if (focus) {
      try { box.focus({ preventScroll: true }); } catch (err) { box.focus(); }
    }
    (details || box).scrollIntoView({ block: 'center', behavior: focus ? 'auto' : 'smooth' });
  }

  var intentOn = false; // mirror of the stored intent, so the observer stays cheap
  function setIntent(on) {
    intentOn = on;
    try {
      if (on) sessionStorage.setItem(INTENT, String(Date.now()));
      else sessionStorage.removeItem(INTENT);
    } catch (err) { /* private mode: the hint still shows */ }
  }
  function hasIntent() {
    try {
      var t = parseInt(sessionStorage.getItem(INTENT), 10);
      return t && Date.now() - t < 30 * 60 * 1000;
    } catch (err) { return false; }
  }

  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el.matches || !el.matches('[data-gp-gift-note]')) return;
    count(el);
    hasNote = el.value.trim() !== '';
    syncLinks();
    clearTimeout(timers.get(el));
    timers.set(el, setTimeout(function () { save(el); }, 600));
  });
  document.addEventListener('focusout', function (e) {
    if (e.target.matches && e.target.matches('[data-gp-gift-note]')) save(e.target);
  });

  // capture phase: the cart drawer stops clicks from bubbling out of it
  document.addEventListener('click', function (e) {
    var summary = e.target.closest && e.target.closest('[data-gp-gift-summary]');
    if (summary) {
      var details = summary.parentNode;
      if (details.open) return; // closing: let the browser do it
      e.preventDefault();
      details.open = true;
      var box = details.querySelector('[data-gp-gift-note]');
      if (box) box.focus();
      return;
    }
    var opener = e.target.closest && e.target.closest('[data-gp-gift-open]');
    if (!opener) return;
    e.preventDefault();
    if (opener.closest('#cartDrawer')) {
      var inBox = drawerBox();
      if (inBox) openRow(inBox, true);
      return;
    }
    // product-page line
    if (cartCount() === 0) {
      // empty cart: say what happens, open the row after the next add
      var label = opener.querySelector('[data-gp-gift-label]');
      var hint = opener.getAttribute('data-gp-gift-hint');
      if (label && hint) {
        label.textContent = hint;
        opener.setAttribute('data-gp-hinted', '');
      }
      setIntent(true);
      return;
    }
    var modals = window.Alpine && Alpine.store && Alpine.store('modals');
    if (modals && modals.open) modals.open('cart');
    // the drawer needs a moment to show (and is only built once the browser
    // is idle); focus there may not raise the iOS keyboard, so the row is
    // open + centered and one tap starts typing
    var tries = 0;
    (function wait() {
      var box = drawerBox();
      if (box && box.offsetParent) {
        setTimeout(function () { openRow(box, false); }, 200);
      } else if (tries++ < 40) {
        setTimeout(wait, 50);
      }
    })();
  }, true);

  // one debounced pass after DOM changes: learn the note from the drawer box,
  // repaint labels (family swaps insert lines rendered before the note), and
  // after an empty-cart tap open the row once the drawer has items
  var queued = false;
  function pass() {
    queued = false;
    var box = drawerBox();
    if (box && document.activeElement !== box) hasNote = box.value.trim() !== '';
    if (intentOn && box && box.offsetParent) {
      setIntent(false);
      document.querySelectorAll('[data-gp-hinted]').forEach(function (b) { b.removeAttribute('data-gp-hinted'); });
      setTimeout(function () { openRow(box, false); }, 300);
    }
    syncLinks();
  }
  intentOn = !!hasIntent();
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(pass);
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });

  // example messages: the first is the placeholder; the rest take turns every
  // few seconds while the box is empty and on screen
  if (!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    var lists = new WeakMap();
    setInterval(function () {
      document.querySelectorAll('[data-gp-gift-note][data-examples]').forEach(function (el) {
        if (el.value !== '' || !el.offsetParent) return;
        var list = lists.get(el);
        if (!list) {
          try {
            list = JSON.parse(el.getAttribute('data-examples')).map(function (x) { return String(x).trim(); }).filter(Boolean);
          } catch (err) { list = []; }
          lists.set(el, list);
        }
        if (list.length < 2) return;
        var i = (list.indexOf(el.placeholder) + 1) % list.length;
        el.placeholder = list[i];
      });
    }, 3200);
  }
})();
